import React from 'react';

import { getReseller, IReseller } from '~/src/dash/api/console-api';
import { IStore } from '~/src/dash/reducers/store';
import { parseLocation } from '~/src/dash/router/routes';
import {
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { LoadingView } from '~/src/dash/views/loading-view';
import { ResellerManagerView } from '~/src/dash/views/reseller-manager-view';

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {}

interface IState {
  reseller?: IReseller;
}

export const ResellerExistingView = decorate(
  {
    redux: (state: IStore) => {
      return {
        session: state.session,
      };
    },
    router: true,
  },
  class extends React.Component<IProps, IState> {
    state = {
      reseller: undefined,
    };

    componentDidMount() {
      const loc = parseLocation(this.props.location.pathname);
      getReseller({
        query: {
          reseller_id: loc.reseller,
        },
      }).then((reseller: IReseller) => {
        this.setState({
          reseller,
        });
      });
    }

    render() {
      return (
        <div>
          {this.state.reseller ? (
            <ResellerManagerView reseller={this.state.reseller} />
          ) : (
            <LoadingView active={true} text='Loading the reseller setting' />
          )}
        </div>
      );
    }
  },
);
